import React, { ReactElement, FunctionComponent, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import FloatingText from '@sport1/react-elements/FloatingText'
import { TestID } from '../utils/PropTypesDefinitions'
import Image from '../BaseComponents/Image'
import LinkProps from '../Link/LinkProps'

export type ExternalLinkProps = {
    /** optional imageUrl that is displayed on the left side of the component */
    imageUrl?: string
    /** info about imageUrl for seo */
    alt?: string
    /**
     * Text of the link you would be directed to on click
     */
    text: string
    /**
     * label to show/ redirect ot the external link
     */
    label: string
    /** href string to navigate to the provided url (web only) */
    href?: string
    /**
     * callback when the user pressed on the component
     *
     * @TJS-type function
     */
    onPress: () => void
} & LinkProps &
    TestID

const ExternalLink: FunctionComponent<ExternalLinkProps> = ({
    imageUrl,
    alt,
    text,
    label,
    href,
    onPress,
    testID,
    webRel,
}): ReactElement => {
    const lables = ` | ${label}`
    return (
        <Touchable onPress={onPress} href={href} webRel={webRel}>
            <Grid
                horizontal
                centerVertical
                noExpand
                backgroundColor="tahitian-4"
                testID={testID}
                borderRadius={22}
                minHeight={36}
            >
                {imageUrl ? (
                    <Grid noExpand borderRadius={18} border={1} borderColor="tahitian-4">
                        <Image
                            size="S"
                            radiusType="circled"
                            imageUrl={imageUrl}
                            alt={alt}
                            width={36}
                        />
                    </Grid>
                ) : null}

                <Grid noExpand marginX={3} paddingBottom="3px">
                    <FloatingText
                        textObjects={[
                            {
                                content: text,
                                textStyle: {
                                    fontSize: 'FS12',
                                    lineHeight: 'LH16',
                                    color: 'onyx',
                                    textDecorationLine: 'underline',
                                },
                            },
                            {
                                content: lables,
                                textStyle: {
                                    fontSize: 'FS12',
                                    lineHeight: 'LH16',
                                    color: 'keshi-3',
                                },
                            },
                        ]}
                    />
                </Grid>
            </Grid>
        </Touchable>
    )
}

export default memo(ExternalLink)
